export const TAG_VERSION = process.env.NEXT_PUBLIC_TAG_VERSION

export const REMOTE_API_BASE_URL = process.env.REMOTE_API_BASE_URL
export const PUBLIC_DOMAIN_URL = process.env.NEXT_PUBLIC_DOMAIN_URL

export const PUBLIC_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL
